/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Empty_Nodata_Title2Inputs */

const id_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data performa`)
};

const ms_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data prestasi`)
};

const da_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ydelsesdata`)
};

const de_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Leistungsdaten`)
};

const en_us2_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No performance data`)
};

const es_es2_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos de rendimiento`)
};

const es_mx2_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos`)
};

const fil_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang data ng pagganap`)
};

const fr_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée de performance`)
};

const it_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato di prestazione`)
};

const hu_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs teljesítmény adat`)
};

const nl_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen prestatiegegevens`)
};

const no_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ytelsesdata`)
};

const pl_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych o wydajności`)
};

const pt_br2_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados de desempenho`)
};

const pt_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados de desempenho`)
};

const ro_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fără date de performanță`)
};

const fi_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei suorituskykytietoja`)
};

const sv_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga prestandadata`)
};

const vi_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu hiệu suất`)
};

const tr_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans verisi yok`)
};

const cs_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná data o výkonu`)
};

const bg_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма данни за производителност`)
};

const ru_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет данных о производительности`)
};

const uk_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає даних продуктивності`)
};

const ar_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات أداء`)
};

const hi_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रदर्शन डेटा नहीं`)
};

const th_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูลประสิทธิภาพ`)
};

const ja_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パフォーマンスデータなし`)
};

const zh_cn2_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无表现数据`)
};

const zh_hant1_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無表現資料`)
};

const ko_components_performancetable_empty_nodata_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nodata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성과 데이터 없음`)
};

/**
* | output |
* | --- |
* | "No performance data" |
*
* @param {Components_Performancetable_Empty_Nodata_Title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_empty_nodata_title2 = /** @type {((inputs?: Components_Performancetable_Empty_Nodata_Title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Empty_Nodata_Title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "ms") return ms_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "da") return da_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "de") return de_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "fil") return fil_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "fr") return fr_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "it") return it_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "hu") return hu_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "nl") return nl_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "no") return no_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "pl") return pl_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "pt") return pt_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "ro") return ro_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "fi") return fi_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "sv") return sv_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "vi") return vi_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "tr") return tr_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "cs") return cs_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "bg") return bg_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "ru") return ru_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "uk") return uk_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "ar") return ar_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "hi") return hi_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "th") return th_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "ja") return ja_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_empty_nodata_title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_empty_nodata_title2(inputs)
	return ko_components_performancetable_empty_nodata_title2(inputs)
});
export { components_performancetable_empty_nodata_title2 as "components.performanceTable.empty.noData.title" }